// External libraries
import gql from 'graphql-tag';

export const CREATE_ONBOARDING_PAYMENT_PLAN_MUTATION = gql`
  mutation CreateOnboardingPaymentPlanMutation(
    $currencyConversionType: CheckoutCurrencyConversionType
    $cvv: String
    $encryptedCardLoginAccountNumber: String
    $fundingInstrumentId: String!
    $shareAddressWithDonatee: Boolean
    $shippingAddress: AddressInput
    $supportedThreeDsExperiences: [ThreeDSPaymentExperience]
    $token: String!
    $userType: OnboardingExperienceType!
  ) {
    createOnboardingPaymentPlan(
      currencyConversionType: $currencyConversionType
      cvv: $cvv
      encryptedCardLoginAccountNumber: $encryptedCardLoginAccountNumber
      fundingInstrumentId: $fundingInstrumentId
      shareAddressWithDonatee: $shareAddressWithDonatee
      shippingAddress: $shippingAddress
      token: $token
      userType: $userType
    ) {
      buyer {
        auth {
          accessToken
        }
        userId
      }
      flags {
        is3DSecureRequired
      }
      paymentContingencies {
        threeDomainSecure(experiences: $supportedThreeDsExperiences) {
          status
          redirectUrl {
            href
          }
          method
          parameter
          experience
          requestParams {
            key
            value
          }
        }
      }
    }
  }
`;
